
<template>
    <div class="login_container">
        <!-- 所有class引用为单引号，才能起作用 -->
        <div class="top">
            <div>企业用户登录入口</div>
        </div>
        
        <div class='login_box'>
            <div class='qiye'></div>
            <div class="">
                 <div class="login">系统登陆1</div> 
                <el-form class='login_box2' :rules="loginFormRoules" ref="loginFormRef" :model="loginForm"
                    label-width="0px">
                    <el-form-item label="" prop="qiye_mob">
                        <el-input v-model="loginForm.qiye_mob"> <i slot="prefix" class="iconfont">&#xe56f;</i></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="qiye_pass">
                        <el-input v-model="loginForm.qiye_pass" type="password"><i slot="prefix"
                                class="iconfont">&#xe56c;</i></el-input>
                    </el-form-item>
                    <el-form-item class='btns'>
                        <el-button type="primary" @click="login">登录</el-button>
                        <el-button type="info" @click="resetLoginForm">重置</el-button>
                    </el-form-item>
                </el-form>
                <!-- </div> -->
            </div>
            
        </div>
        <div class="buttom">
            <div>版权所有：{{copyright}} </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            copyright: '',
            loginForm: {
                C_type: 'qiye_login',
                qiye_mob: '',
                qiye_pass: ''
            },
            loginFormRoules: {
                qiye_mob: [
                    { required: true, message: '请输入登录名称', trigger: 'blur' },
                    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在6 个字符以上', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        window.sessionStorage.setItem('tokenUserType', 1) // 写入登录用户的类型 2 为管理员
        window.sessionStorage.setItem('pageSize', 10) //  单页记录数量
        this.copyright = '系统登陆'
        window.sessionStorage.setItem('copyright', this.copyright)
    },
    methods: {
        // 点击重置登录按钮
        resetLoginForm() {
            // console.log(this)
            this.$refs.loginFormRef.resetFields()
        },

        login() {
            // console.log('123')
            this.$refs.loginFormRef.validate(async (valid) => { // 表单预校验
                //  console.log(valid)
                if (!valid) return;
                // var params = new URLSearchParams()
                // 参数保存
                // const result = await this.$http.post('api', this.loginForm)
                // console.log(result)
                const { data: res } = await this.$http.post('api', this.loginForm)
                // awit 只能用在被async修饰都方法中，用来简化 promise返回的数据
                // data: res  解构 返回数据中的data对象，然后重新赋值给res
                // 对象解构用{}，变量解构用[]
                //   console.log(res.Admin_test_Flag)
                if (res.Qiye_test_Flag !== 1) return this.$message.error('登录失败！')
                this.$message.success('登陆成功')
                // const token = res.token // 该torken 用来读取其他出登录api之外的接口 ，保存在sessionStorage
                  console.log('res', res)
                window.sessionStorage.setItem('token', res.token)
                window.sessionStorage.setItem('isMember', res.isMember)
                window.sessionStorage.setItem('qiye_mob', this.loginForm.qiye_mob)
                // console.log('this.loginForm.qiye_uid', this.loginForm.qiye_mob) 
                window.sessionStorage.setItem('qiye_uid', res.qiye_uid)
                window.sessionStorage.setItem('qiye_name', res.qiye_name)
                window.sessionStorage.setItem('picShoukuanma', res.picShoukuanma)
                this.$router.push('/yysHome')
            })
        }
    }
};
</script>
<style lang="less" scoped> // scoped 限制在本组件中样式生效

 .login_container {
     background-color: #f6f6f6;
     width: 100%;
     height: 100%;
     //  background: url("../assets/img/bg3.jpg") no-repeat;
     background-size: 100% 100%;
     background-attachment: fixed;
    
 }

 .qiye {
     width: 300px;
     height: 130px;
     border-radius: 50%;
     padding: 10px;
     font-size: 30px;
     position: absolute;
     color: #444;
     font-weight: 4030;
     left: 50%;
     transform: translate(-40%, -90%);

 }

 .login_box {
     width: 380px;
     height: 300px;
     background-color: white;
     border-radius: 3px;
     position: absolute;
     left: 50%;
     top: 50%;
     transform: translate(-50%, -50%);
 }

 .avatar_box {
     width: 130px;
     height: 130px;
     border: 1px solid #eee;
     border-radius: 50%;
     padding: 10px;
     box-shadow: 0 0 10px #ddd;
     position: absolute;
     left: 50%;
     transform: translate(-50%, -50%);
     background-color: #fff;

     img {
         width: 100%;
         height: 100%;
         border-radius: 50%;
         background-color: #eee;
     }
 }

 .login_box2 {
     padding-top: 50px;
     position: absolute;
     bottom: 0px;
     padding: 0 20px;
     box-sizing: border-box;
     width: 100%;
 }

 .btns {
     display: flex;
     justify-content: flex-end;
 }

 .title_pzeiot {
     padding-top: 120px;
     padding-left: 85px;

 }

 .top {
     background: #2b2f3a;
     color: #fff;
     height: 50px;
     display: flex;
     flex-direction: row;
     justify-content: center;
     align-items: center;
     //  font-weight: 500;

 }

 .buttom {
     background: #fff;
     color: #2b2f3a;
     height: 60px;
     display: flex;
     flex-direction: row;
     justify-content: center;
     align-items: center;
     //  font-weight: 500;
     font-size:small;
     bottom: 0px;
     position: fixed;
     width: 100%;
 }
 .login{
    text-align: center;
    display: flex;
    background-color: #2b2f3a;
    border-radius: 5px 5px 0px 0px;
    height: 60px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: large;
    color: antiquewhite;
    
 }
</style>
